import { Injectable } from "@angular/core";
import { UtilsService } from "./utils.service";
import { ContractService } from "./contract.service";
import { UserService } from "./user.service";
import moment from "moment";
import { ToastrService } from "ngx-toastr";

@Injectable({
  providedIn: "root",
})
export class ManageBargainingContractService {
  public data: any = {
    level: "",
    role: null,
    start_date: null,
    end_date: null,
    trial: "",
    program: "full time",
    contract: null,
    gross_monthly_12: 0,
    net_monthly_12: 0,
    net_monthly_13: 0,
    total_net_monthly_13: 0,
    salary_yearly_gross: 0,
    total_daily: 0,
    bonus: 0,
    production_bonus: 0,
    ticket_card: null,
    ticket_month_number: 0,
    ticket_value: 0,
    ticket_type: "fisso",
    ticket_total: 0,
    tutor_hash: null,
    record_type: "desiderata",
    company_office_id: null,
  };

  private economic_fields: string[] = ["gross_monthly_12", "net_monthly_12", "net_monthly_13", "total_net_monthly_13", "salary_yearly_gross", "total_daily", "bonus", "production_bonus", "ticket_total", "ticket_value"];

  public levels_for_select: any = [];

  private levels_list: any = [];

  public costs: any = [];

  public current_lvl: any;

  public next_lvl: any;

  public tutors: any = [];

  public contractDuration: number = 0;

  public typeIsIndeterminate: boolean = false;

  public typeIsApprendistato: boolean = false;

  public typeIsStage: boolean = false;

  constructor(
    private _utils: UtilsService,
    private _toastService: ToastrService,
    private _contractService: ContractService,
    private _userService: UserService,
  ) { }

  async init(saved_data: any = null) {
    this.costs = await this._contractService.getCosts();
    this.tutors = await this._userService.getList("employee");
    await this._contractService.getLevels();

    if (saved_data) {
      const data: any = JSON.parse(JSON.stringify(saved_data));

      this.data.contract = data.contract;
      this.data.level = data.level;

      const numericKeys: string[] = [
        "salary_yearly_gross",
        "net_monthly_12",
        "net_monthly_13",
        "bonus",
        "production_bonus",
        "ticket_value",
        "total_daily",
        "total_net_monthly_13",
        "gross_monthly_12",
        "ticket_month_number",
        "trial",
      ];
      numericKeys.map((key: string) => {
        if (data.hasOwnProperty(key) && data[key]) {
          this.data[key] = Number(data[key]);
        }
      });

      this.data.ticket_total = this.data.ticket_value * this.data.ticket_month_number;

      if (data.role) {
        this.data.role = data.role;
      }
      if (data.role_id) {
        this.data.role = data.role_id;
      }
      if (data.tutor) {
        this.data.tutor_hash = data.tutor.hash;
      }
      if (data.ticket_type) {
        this.data.ticket_type = data.ticket_type;
      }
      if (data.program) {
        this.data.program = data.program;
      }

      if (data.start_date) {
        this.data.start_date = data.start_date;
      }

      if (data.end_date) {
        this.data.end_date = data.end_date;
      }

      if (data.company_office_id) {
        this.data.company_office_id = data.company_office_id;
      }

      this.typeIsIndeterminate = data.contract_name === "Indeterminato";
      this.typeIsApprendistato = data.contract_name === "Apprendistato";
      this.typeIsStage = data.contract_name === "Stage";
      this.current_lvl = this.costs.filter((cost: any) => Boolean(cost.is_apprendistato) === this.typeIsApprendistato && cost.level === this.data.level)[0];

      if (this.typeIsStage) {
        this.data.total_daily = this.data.net_monthly_12 / 20;
      } else {
        this.getLevels();
        const { currentLvl }: any = this.getLevelsData();
        if (!saved_data.total_daily) {
          this.data.total_daily = Number(currentLvl.total_daily) + this.data.bonus / 20 + this.data.production_bonus / 12 / 20 + this.data.ticket_total / 20;
        } else {
          this.data.total_daily = this._utils.addDotsToNumber(saved_data.total_daily);
        }

        if (!saved_data.total_net_monthly_13) {
          this.data.total_net_monthly_13 = this.data.net_monthly_13 + this.data.bonus + this.data.production_bonus / 12;
        }

        if (this.typeIsApprendistato) {
          if (!!data.start_date && !!data.end_date) {
            const start: any = moment(data.start_date);
            const end: any = moment(data.end_date).add(1, "day");
            this.contractDuration = end.diff(start, "months");
          } else {
            this.contractDuration = 36;
          }
        }
      }

      this.addDots();

      if (!this.typeIsStage) {
        this.changeLevel(false, false, false);
      }
    }
  }

  addDots() {
    const formatter: any = new Intl.NumberFormat("it-IT", {
      style: "currency",
      currency: "EUR",
    });

    Object.keys(this.data).map((key: string) => {
      if (this.data[key] && typeof this.data[key] !== "string" && this.economic_fields.includes(key)) {
        this.data[key] = formatter.format(this.data[key]).replace("€", "").trim();
        if (!this.data[key].includes(",")) {
          this.data[key] += ",00";
        }
      }
    });
  }

  async changeSalaryGrossYearly(value) {
    if (!this.levels_list || this.levels_list.length < 1) {
      this.getLevels();
    }

    if (typeof value === "string") {
      value = value.split("");
      if (value[2] === "." && value[value.length - 3] === ".") {
        delete value[2];
      }
      value = value.join("");
      if (value.includes(",")) {
        value = value.replace(",", ".");
      }
      value = Number(value);
    }

    if (!this.data.salary_yearly_gross.includes(".")) {
      this.data.salary_yearly_gross = this._utils.addDotsToNumber(this.data.salary_yearly_gross);
    }

    if (this.typeIsApprendistato) {
      const first: any = this.levels_list[0];
      const last: any = this.levels_list[this.levels_list.length - 1];

      // se la ral inserita è minore/uguale del primo livello impostiamo il primo livello
      if (value <= first.salary_yearly_gross) {
        this.data.level = first.level;
        await this.showPopupEditLevel("UP");
        this.changeLevel(false, false);
      }
      // se la ral inserita è maggiore/uguale dell'ultimo livello impostiamo l'ultimo livello
      else if (value >= last.salary_yearly_gross) {
        this.data.level = last.level;
        await this.showPopupEditLevel("DOWN");
        this.changeLevel(false, false);
      }
      // se la ral inserita è fra il primo e l'ultimo livello ci andiamo a cercare quello che più si avvicina alla ral inserita
      else {
        let currentLvl: any;
        this.levels_list.map(async (cost: any, i: number) => {
          if (!currentLvl && cost.salary_yearly_gross <= value && this.levels_list[i + 1].salary_yearly_gross >= value) {
            this.data.level = cost.level;
            currentLvl = cost;
          }
        });
        this.changeLevel(false, false, false);
        setTimeout(() => this.afterChangeRAL());
      }
    } else {
      const costsList: any = !this.typeIsApprendistato ? this.levels_list : this.costs.filter((cost: any) => cost.is_apprendistato === 1 && cost.year === 3);

      const max: any = Number(costsList[costsList.length - 1].salary_yearly_gross);
      const min: any = Number(costsList[0].salary_yearly_gross);

      if (max <= value) {
        this.data.level = this.levels_list[this.levels_list.length - 1].level;
        const listValidLvl: any = this.costs.filter((c: any) => c.level == this.data.level && c.is_apprendistato === Number(this.typeIsApprendistato));
        this.current_lvl = listValidLvl[listValidLvl.length - 1];
        this.data.salary_yearly_gross = this._utils.addDotsToNumber(value);
        this.changeLevel(false, false, false);
        setTimeout(() => this.afterChangeRAL());
      } else if (min >= value) {
        this.data.level = this.levels_list[0].level;
        this.changeLevel(false, false, false);
        setTimeout(() => this.updateData());
      } else {
        let founded: boolean = false;
        this.levels_list.map((cost: any, i: number) => {
          if (!founded && Number(cost.salary_yearly_gross) <= value && Number(this.levels_list[i + 1].salary_yearly_gross) >= value) {
            founded = true;
            this.data.level = cost.level;
            this.data.salary_yearly_gross = this._utils.addDotsToNumber(value);
            this.changeLevel(false, false, false);
            setTimeout(() => this.afterChangeRAL());
          }
        });
      }
    }
  }

  afterChangeRAL() {
    const ral = this._utils.removeDotsFromNumber(this.data.salary_yearly_gross);

    // decido con che livello fare le proporzioni scegliendo quello più vicino alla ral impostata
    const theshold: number = Number(this.current_lvl.salary_yearly_gross) + (Number(this.next_lvl?.salary_yearly_gross) - Number(this.current_lvl?.salary_yearly_gross)) / 2;
    let lvlToCompare: any = ral > theshold ? this.next_lvl : this.current_lvl;

    if (this.current_lvl.level === "B3") {
      const b3List: any = this.costs
        .filter((c: any) => c.level === "B3" && c.is_apprendistato === Number(this.typeIsApprendistato))
        .sort((a: any, b: any) => {
          a = Number(a.salary_yearly_gross);
          b = Number(b.salary_yearly_gross);
          return a > b ? 1 : a < b ? -1 : 0;
        })
        .map((c: any) => {
          c.salary_yearly_gross = Number(c.salary_yearly_gross);
          return c;
        });

      if (ral >= b3List[b3List.length - 1].salary_yearly_gross - 1) {
        lvlToCompare = b3List[b3List.length - 1];
      } else {
        let currentLvlB3: any;
        let nextLvlB3: any;
        b3List.map((cost: any, i: number) => {
          if (!currentLvlB3 && cost.salary_yearly_gross <= ral && b3List[i + 1].salary_yearly_gross >= ral) {
            currentLvlB3 = cost;
            nextLvlB3 = b3List[i + 1];
          }
        });

        const theSholdB3: any = Number(currentLvlB3.salary_yearly_gross) + (Number(nextLvlB3.salary_yearly_gross) - Number(currentLvlB3.salary_yearly_gross)) / 2;
        lvlToCompare = ral > theSholdB3 ? nextLvlB3 : currentLvlB3;
      }
    }

    const newData: any = {};

    // retribuzione lorda mensile = ral / 12
    newData.gross_monthly_12 = Number((ral / 12).toFixed(2));
    // nuova_ral: nuovo_netto_12 = compare_ral: compare_netto_12
    newData.net_monthly_12 = Number((lvlToCompare.net_monthly_12 * ral) / lvlToCompare?.salary_yearly_gross).toFixed(2);
    // nuova_ral: nuovo_netto_13 = compare_ral: compare_netto_13
    newData.net_monthly_13 = Number((lvlToCompare?.net_monthly_13 * ral) / lvlToCompare?.salary_yearly_gross).toFixed(2);
    // nuova_ral: nuovo_totale_giornaliero = compare_ral: compare_totale_giornaliero
    newData.total_daily = (lvlToCompare?.total_daily * ral) / lvlToCompare?.salary_yearly_gross;

    this.data = { ...this.data, ...newData, salary_yearly_gross: ral };

    if (typeof this.data.bonus === "string" && this.data.bonus.includes(",")) {
      this.data.bonus = this._utils.removeDotsFromNumber(this.data.bonus);
    }
    if (typeof this.data.bonus === "string" && this.data.production_bonus.includes(",")) {
      this.data.production_bonus = this._utils.removeDotsFromNumber(this.data.production_bonus);
    }

    this.data.total_net_monthly_13 = this.data.net_monthly_13 + this.data.bonus + this.data.production_bonus / 12;
    this.data.total_daily += this._utils.removeDotsFromNumber(this.data.ticket_value || "0") + this.data.bonus / 20 + this.data.production_bonus / 12 / 20;

    this.addDots();
  }

  resetData(exclude_role: boolean = false, exclude_date: boolean = false) {
    this.data.level = null;
    this.data.trial = null;
    this.data.program = "full time";
    this.data.contract = null;
    this.data.gross_monthly_12 = 0;
    this.data.net_monthly_12 = 0;
    this.data.net_monthly_13 = 0;
    this.data.total_net_monthly_13 = 0;
    this.data.salary_yearly_gross = 0;
    this.data.total_daily = 0;
    this.data.bonus = 0;
    this.data.production_bonus = 0;
    this.data.ticket_card = null;
    this.data.ticket_month_number = 0;
    this.data.ticket_value = 0;
    this.data.ticket_type = "fisso";
    this.data.ticket_total = 0;
    this.data.record_type = "desiderata";

    if (!exclude_role) {
      this.data.role = null;
    }

    if (!exclude_date) {
      this.data.start_date = null;
      this.data.end_date = null;
    }
  }

  getLevels() {
    const isApprendistato: number = this.typeIsApprendistato ? 1 : 0;
    this.levels_list = this.costs.filter((lvl: any) => lvl.is_apprendistato === isApprendistato);

    if (isApprendistato) {
      this.levels_list = this.levels_list.filter((lvl: any) => lvl.year === 3);
    }

    this.levels_list = this.levels_list.sort((a: any, b: any) => {
      a = parseFloat(a.salary_yearly_gross);
      b = parseFloat(b.salary_yearly_gross);
      return a > b ? 1 : a < b ? -1 : 0;
    });

    this.levels_for_select = [];
    this.levels_list.map((lvl: any) => {
      if (!this.levels_for_select.includes(lvl.level)) {
        this.levels_for_select.push(lvl.level);
      }
    });
  }

  changeContract($event: any) {
    this.resetData(true, true);
    this.data.contract = $event.id;

    this.typeIsIndeterminate = $event.name === "Indeterminato";
    this.typeIsApprendistato = $event.name === "Apprendistato";
    this.typeIsStage = false;

    if (this.typeIsApprendistato) {
      this.contractDuration = 36;
    }

    if ($event.name === "Stage") {
      this.levels_for_select = [];
      this.typeIsStage = true;
      this.data.net_monthly_12 = "800,00";
      this.data.total_daily = "40,00";
      return false;
    }

    setTimeout(() => {
      this.getLevels();

      setTimeout(() => {
        this.updateData();
      }, 100);
    });
  }

  getLevelsData() {
    const name: string = this.data.level;
    let currentLvl: any = null;
    let nextLvl: any = null;
    switch (name) {
      case "B3":
        const b3List: any = this.levels_list.filter((c: any) => c.level === name);
        currentLvl = b3List[0];
        nextLvl = b3List[b3List.length - 1];
        break;
      default:
        currentLvl = this.levels_list.find((c: any, index: number) => {
          if (c.level === name) {
            nextLvl = this.levels_list[index + 1];
            return c;
          }
        });
        break;
    }

    for (let key of Object.keys(currentLvl)) {
      if (typeof currentLvl[key] === "string" && this.economic_fields.includes(key)) {
        currentLvl[key] = Number(currentLvl[key]);
      }
    }

    for (let key of Object.keys(nextLvl)) {
      if (typeof nextLvl[key] === "string" && this.economic_fields.includes(key)) {
        nextLvl[key] = Number(nextLvl[key]);
      }
    }

    return { currentLvl, nextLvl };
  }

  changeLevel(fromInput: boolean = false, resetDates: boolean = true, update: boolean = true) {
    setTimeout(() => {
      const { currentLvl, nextLvl }: any = this.getLevelsData();
      this.current_lvl = currentLvl;
      this.next_lvl = nextLvl;

      if (fromInput) {
        this.data.net_monthly_12 = 0;
        this.data.net_monthly_13 = 0;
        this.data.total_daily = 0;
        this.data.salary_yearly_gross = 0;
      }

      if (resetDates) {
        this.data.start_date = "";
        this.data.end_date = "";
      }

      this.data.trial = this.current_lvl.trial;

      if (update) {
        this.updateData();
      }
    });
  }

  public updateDataFromBonus(new_bonus: number) {
    new_bonus = Number(new_bonus);
    const old_bonus = this.data.bonus;
    this.data.bonus = new_bonus;

    const daily_production_bonus = this._utils.removeDotsFromNumber(this.data.production_bonus) / 12 / 20;
    const total_daily = this._utils.removeDotsFromNumber(this.data.total_daily || 0);
    const ticket_value = this._utils.removeDotsFromNumber(this.data.ticket_value || 0);

    const clean_total_daily = total_daily - ticket_value - old_bonus / 20 - daily_production_bonus;
    this.data.total_daily = this._utils.addDotsToNumber(clean_total_daily + ticket_value + new_bonus / 20 + daily_production_bonus);
  }

  public updateDataFromProductionBonus(new_production_bonus: number) {
    new_production_bonus = Number(new_production_bonus);
    const old_production_bonus = this.data.production_bonus;
    this.data.production_bonus = new_production_bonus;

    const old_monthly_production_bonus = old_production_bonus / 12;
    const new_monthly_production_bonus = new_production_bonus / 12;
    const total_net_monthly_13 = this._utils.removeDotsFromNumber(this.data.total_net_monthly_13)
    this.data.total_net_monthly_13 = this._utils.addDotsToNumber(total_net_monthly_13 - old_monthly_production_bonus + new_monthly_production_bonus)


    const old_daily_production_bonus = old_monthly_production_bonus / 20;
    const new_daily_production_bonus = new_monthly_production_bonus / 20;
    const total_daily = this._utils.removeDotsFromNumber(this.data.total_daily)
    this.data.total_daily = this._utils.addDotsToNumber(total_daily - old_daily_production_bonus + new_daily_production_bonus)
  }

  public updateData(fromField: string = "") {
    if (!this.data.level || this.data.level.length < 1) {
      return false;
    }
    if (this.typeIsStage) {
      this.data.net_monthly_12 = typeof this.data.net_monthly_12 === "string" ? this._utils.removeDotsFromNumber(this.data.net_monthly_12) : this.data.net_monthly_12;
      this.data.total_daily = this.data.net_monthly_12 / 20;
    } else {
      if (String(this.data.bonus).length < 1) {
        this.data.bonus = 0;
      }
      if (String(this.data.production_bonus).length < 1) {
        this.data.production_bonus = 0;
      }

      if (String(this.data.ticket_total).length < 1) {
        this.data.ticket_total = 0;
      }

      if (typeof this.data.ticket_total === "string") {
        this.data.ticket_total = this._utils.removeDotsFromNumber(this.data.ticket_total);
      }

      if (typeof this.data.bonus === "string") {
        this.data.bonus = this._utils.removeDotsFromNumber(this.data.bonus);
      }
      if (typeof this.data.production_bonus === "string") {
        this.data.production_bonus = this._utils.removeDotsFromNumber(this.data.production_bonus);
      }

      if (this.data.trial && this.data.trial.length < 1) {
        this.data.trial = this.current_lvl.trial;
      }

      this.economic_fields.map((key: string) => {
        if (typeof this.data[key] === "string" && this.data[key].includes(",")) {
          this.data[key] = this._utils.removeDotsFromNumber(this.data[key]);
        }
      });

      const { currentLvl }: any = this.getLevelsData();

      const dataCosts: any = {};
      for (const k of Object.keys(this.data)) {
        if (!isNaN(Number(this.data[k]))) {
          dataCosts[k] = Number(this.data[k]);
        } else {
          dataCosts[k] = this.data[k];
        }
      }

      dataCosts.daily_production_bonus = dataCosts.production_bonus / 12 / 20;
      dataCosts.daily_bonus = dataCosts.bonus / 20;

      if (fromField == "ticket") {
        this.data.ticket_total = dataCosts.ticket_value * dataCosts.ticket_month_number + dataCosts.ticket_total / 20;
      } else {
        this.data.salary_yearly_gross = dataCosts.salary_yearly_gross || currentLvl.salary_yearly_gross;
        this.data.gross_monthly_12 = Number((currentLvl.salary_yearly_gross / 12).toFixed(2));
        this.data.trial = currentLvl.trial;
        this.data.net_monthly_12 = Number((currentLvl.net_monthly_12).toFixed(2));
        this.data.net_monthly_13 = Number((currentLvl.net_monthly_13).toFixed(2));
        this.data.total_net_monthly_13 = Number((currentLvl.net_monthly_13 + dataCosts.bonus + dataCosts.production_bonus / 12).toFixed(2));
        this.data.ticket_total = dataCosts.ticket_value * dataCosts.ticket_month_number;
        this.data.total_daily = currentLvl.total_daily + dataCosts.ticket_total / 20 + dataCosts.bonus / 20 + dataCosts.production_bonus / 12 / 20;
      }

      if (this.typeIsApprendistato && this.data.start_date) {
        this.data.end_date = moment(this.data.start_date, "YYYY-MM-DD").add(this.contractDuration, "months").subtract(1, "day").format("YYYY-MM-DD");
      }
    }

    if (typeof this.data.ticket_value === "string") {
      this.data.ticket_value = this._utils.removeDotsFromNumber(this.data.ticket_value);
    }

    this.addDots();
  }

  private async showPopupEditLevel(direction: string) {
    const message: any = await this._utils.translate("ALERT.WARNING_CHANGING_CONTRACT_LEVEL_" + direction);
    this._toastService.info(message);
  }
}
